import { compact } from 'lodash-es'

export const state = () => ({
  getLocations: [],
  getJobTypes: [],
  categorizedPoolsList: [],
  orphanPoolsList: []
})

export const actions = {
  async getLocations({ commit }, payload) {
    try {
      const { data: locations } = await this.$api.project.getJobsLocations(payload)

      const treeList = []
      const countryList = [...new Set(locations.map(({ country }) => country))]

      for (let i = 0; i < countryList.length; i++) {
        const iso = countryList[i]

        treeList.push(
          {
            id: `country_${i}`,
            name: this.$parseCountryName(iso),
            value: iso,
            country: iso,
            isCountry: true
          },
          ...compact(
            locations.map((e, idx) => {
              if (e.country === iso) {
                return {
                  id: `city_${i}_${idx}`,
                  name: e.city,
                  value: e.city,
                  country: iso
                }
              } else {
                return null
              }
            })
          )
        )
      }

      commit('GET_LOCATIONS', treeList)
    } catch ({ response }) {
      console.log(`API REQUEST FAILED FOR SITE LOCATIONS`)
    }
  },

  async getPools({ state, commit }, payload) {
    try {
      const makePoolsList = (pools) =>
        pools
          .map((pool) => ({
            ...pool,
            name: this.$i18n.t(pool.poolNameVerbiage),
            description: this.$i18n.t(pool.poolDescriptionVerbiage)
          }))
          .sort((a, b) => a.name.localeCompare(b.poolNameVerbiage))

      const { data } = await this.$api.utils.getBreadcrumbs({ locations: false })

      const pools = [...(data?.poolBreadcrumbs ?? [])]

      const hasAnyCategoryId = pools.some((pool) => typeof pool.category_id === 'number')

      const categorizedPools = []
      const orphanPools = []

      if (hasAnyCategoryId) {
        try {
          const { data: categoriesData } = await this.$api.cms.getCategories([
            'id',
            'translations.code',
            'translations.name'
          ])

          const categoryIds = categoriesData.map(({ id }) => id)

          for (const pool of pools) {
            if (categoryIds.includes(pool.category_id)) {
              categorizedPools.push(pool)
            } else {
              orphanPools.push(pool)
            }
          }

          const categories = categoriesData
            .reduce((acc, cat) => {
              const rawChildren = categorizedPools.filter(
                // eslint-disable-next-line camelcase
                ({ category_id }) => category_id === cat.id
              )

              if (rawChildren.length) {
                acc.push({
                  id: cat.id,
                  name: this.app.$cmsTranslation(cat, 'name'),
                  children: makePoolsList(rawChildren)
                })
              }

              return acc
            }, [])
            .sort((a, b) => a.name.localeCompare(b.name))

          commit('GET_CATEGORIZED_POOLS', categories)
        } catch (error) {
          console.error('[CMS FAILED]', error)
          orphanPools.push(...pools)
        }
      } else {
        orphanPools.push(...pools)
      }

      if (orphanPools.length) {
        const orphans = makePoolsList(orphanPools)
        commit('GET_ORPHAN_POOLS', orphans)
      }
    } catch (error) {
      console.error('[POOLS FAILED]', error)
    }
  },

  async getJobTypes({ commit }, payload) {
    try {
      const clientName = payload
      const { data: jobTypes } = await this.$api.project.getJobTypes(clientName)

      commit('GET_JOB_TYPES', jobTypes)
    } catch (error) {
      console.error('[JOB TYPES FAILED]', error)
    }
  }
}

export const mutations = {
  GET_LOCATIONS: (state, payload) => {
    state.getLocations = payload
  },

  GET_CATEGORIZED_POOLS: (state, payload) => {
    state.categorizedPoolsList = payload
  },

  GET_ORPHAN_POOLS: (state, payload) => {
    state.orphanPoolsList = payload
  },

  GET_JOB_TYPES: (state, payload) => {
    state.getJobTypes = payload
  }
}

export const getters = {
  getLocations: (state) => {
    return state.getLocations
  },

  categorizedPoolsList: (state) => {
    return state.categorizedPoolsList
  },

  orphanPoolsList: (state) => {
    return state.orphanPoolsList
  },

  getJobTypes: (state) => {
    return state.getJobTypes
  }
}
